var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"count",attrs:{"tabindex":1}},[_c('p',{staticClass:"numgal"},[_vm._v("+"+_vm._s(_vm.count))])])}
var staticRenderFns = []

export { render, staticRenderFns }